import React, {useContext} from 'react';
import { Context } from './Context';
import Result from './Result';

export default function QuizBoard() {
    
    const { Logo, randomCountry, showNext, randomOptions, checkWin, randomNumber, handleResult, isLoading } = useContext(Context);

    function RandomizeTwoQuestions() {
        const isEvenRandomNumber = randomNumber % 2 == 0;
        const question = isEvenRandomNumber ? `${randomCountry.capital} is the capital of?` : `Which country does this flag belong to?`
        return (
            <div className="questions">
                <div className={isEvenRandomNumber ? "question_country--name": "question_flag"}>
                    <img className="logo" width="162px" src={Logo}/>
                    {!isEvenRandomNumber && <img className="flag" width="84px" src={randomCountry.flags.png} alt="Country flag" /> }
                    <h2 className={isEvenRandomNumber ? "question1" : "question2"}>{question}</h2> 
                </div>
            </div>
        )
    }
    
    return (  
        isLoading ? <p className="loading">Loading...</p> :
        (randomCountry !== null ?
        <>
            <RandomizeTwoQuestions/> 
            <form onClick={e => checkWin(e)}>
                {randomOptions[0] && <button disabled={showNext} className={`btn`} value={randomOptions[0]}><span className="A"></span><span className="btn_content">{randomOptions[0]}</span><span className="after--icon"></span></button>}
                {randomOptions[1] && <button disabled={showNext} className={`btn`} value={randomOptions[1]}><span className="B"></span><span className="btn_content">{randomOptions[1]}</span><span className="after--icon"></span></button>}
                {randomOptions[2] && <button disabled={showNext} className={`btn`} value={randomOptions[2]}><span className="C"></span><span className="btn_content">{randomOptions[2]}</span><span className="after--icon"></span></button>}
                {randomOptions[3] && <button disabled={showNext} className={`btn`} value={randomOptions[3]}><span className="D"></span><span className="btn_content">{randomOptions[3]}</span><span className="after--icon"></span></button>}
            </form>
            {showNext && <button className="next--btn" onClick={handleResult}>Next</button>}
        </>    
        : <Result/>
        )
    )
}